/*
 * Flash-sale variant picker — assets/flash-variant-picker.js
 *
 * Drives the option-per-control picker rendered by
 * snippets/flash-variant-picker.liquid. Each `.fsp-vp` block carries a JSON
 * list of its product's variants; this resolves the selected combination to a
 * variant id, writes it into the hidden input the form submits, swaps the card
 * hero image when a colour changes, and greys out combinations that cannot be
 * bought (e.g. Adult Arm Sleeve stocks L/XL only in Cotton Candy).
 *
 * Written 2026-07-28, replacing a flat one-chip-per-variant list whose labels
 * ("Elephant Print / L/XL") overflowed their chips on the live page.
 */
(function () {
  'use strict';

  function parseVariants(root) {
    var tag = root.querySelector('script[data-fsp-variants]');
    if (!tag) return [];
    try {
      return JSON.parse(tag.textContent) || [];
    } catch (e) {
      return [];
    }
  }

  function selectedValues(root) {
    var vals = [];
    root.querySelectorAll('.fsp-vp-opt').forEach(function (opt) {
      var i = parseInt(opt.getAttribute('data-opt-index'), 10);
      var chosen = opt.querySelector('[data-fsp-val].is-selected');
      vals[i] = chosen ? chosen.getAttribute('data-fsp-val') : null;
    });
    return vals;
  }

  function matches(variant, vals, ignoreIndex) {
    for (var i = 0; i < vals.length; i++) {
      if (i === ignoreIndex) continue;
      if (vals[i] == null) continue;
      if (variant.o[i] !== vals[i]) return false;
    }
    return true;
  }

  function findVariant(variants, vals) {
    for (var i = 0; i < variants.length; i++) {
      if (matches(variants[i], vals, -1)) return variants[i];
    }
    return null;
  }

  function setHero(root, url) {
    if (!url) return;
    var card = root.closest('.fsp-card');
    if (!card) return;
    var hero = card.querySelector('.fsp-card-media img');
    if (hero) hero.src = url;
  }

  function refresh(root) {
    var variants = parseVariants(root);
    if (!variants.length) return;
    var vals = selectedValues(root);

    // Grey out any value that has no purchasable variant given the other picks.
    root.querySelectorAll('.fsp-vp-opt').forEach(function (opt) {
      var oi = parseInt(opt.getAttribute('data-opt-index'), 10);
      opt.querySelectorAll('[data-fsp-val]').forEach(function (btn) {
        var val = btn.getAttribute('data-fsp-val');
        var possible = variants.some(function (v) {
          return v.o[oi] === val && v.a && matches(v, vals, oi);
        });
        btn.classList.toggle('is-unavailable', !possible);
      });
    });

    var variant = findVariant(variants, vals);
    var input = root.querySelector('[data-fsp-vp-input]');
    var form = root.closest('form');
    var atc = form ? form.querySelector('.fsp-atc, button[type="submit"]') : null;

    if (variant && variant.a) {
      if (input) input.value = variant.id;
      if (atc) {
        atc.disabled = false;
        atc.removeAttribute('aria-disabled');
        if (atc.dataset.fspLabel) {
          atc.textContent = atc.dataset.fspLabel;
          delete atc.dataset.fspLabel;
        }
      }
      if (variant.img) setHero(root, variant.img);
    } else {
      if (input) input.value = '';
      if (atc) {
        if (!atc.dataset.fspLabel) atc.dataset.fspLabel = atc.textContent;
        atc.disabled = true;
        atc.setAttribute('aria-disabled', 'true');
        atc.textContent = 'Sold out';
      }
    }
  }

  function onClick(e) {
    var btn = e.target.closest('[data-fsp-val]');
    if (!btn) return;
    var root = btn.closest('[data-fsp-vp]');
    if (!root) return;
    e.preventDefault();

    var oi = btn.getAttribute('data-opt-index');
    var group = root.querySelector('.fsp-vp-opt[data-opt-index="' + oi + '"]');
    if (!group) return;

    group.querySelectorAll('[data-fsp-val]').forEach(function (b) {
      b.classList.remove('is-selected');
      b.setAttribute('aria-checked', 'false');
    });
    btn.classList.add('is-selected');
    btn.setAttribute('aria-checked', 'true');

    refresh(root);
  }

  function init() {
    var roots = document.querySelectorAll('[data-fsp-vp]');
    if (!roots.length) return;
    roots.forEach(refresh);
    document.addEventListener('click', onClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
